import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

import { authentication } from "./authentication.reducer";
import { alert } from "./alert.reducer";
import { alerts } from "./alerts.reducer";
import { dashboard } from "./dashboard.reducer";
import { energy } from "./energy.reducer";
import { rankings } from "./rankings.reducer";
import { appliance } from "./appliance.reducer";
import { appliances } from "./appliances.reducer";
import { account } from "./account.reducer";
import { activity } from "./activity.reducer";
import { activityDetail } from "./activityDetail.reducer";
import { setup } from "./setup.reducer";
import { feedback } from "./feedback.reducer";
import { popup } from "./popup.reducer";
import { password } from "./password.reducer";
import { accountHomeView } from "./accountHomeView.reducer";

const rootReducer = combineReducers({
  authentication,
  alert,
  alerts,
  dashboard,
  energy,
  rankings,
  appliance,
  appliances,
  account,
  activity,
  activityDetail,
  setup,
  feedback,
  popup,
  password,
  form: formReducer,
  accountHomeView
});

export default rootReducer;
